import React from 'react';
import {
  Box, Divider,
  Grid, Link, makeStyles, Typography,
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSetRecoilState } from 'recoil';
import StepperBooking from './Layout/StepperBooking';
import { maxWidth } from '../config/config';
import SignupForm from './ScreenSignup/SignupForm';
import SelectedTimeSlotDetails from './Common/SelectedTimeSlotDetails';
import { selectedTimeSlotState } from '../state/selected';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(11),
  },
  wrapperContent: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  inner: {
    maxWidth: maxWidth + theme.spacing(2),
  },
  colsWrapper: {
    marginTop: theme.spacing(4),
  },
}));

const ScreenSignup = () => {
  const classes = useStyles();
  const intl = useIntl();
  const setSelectedTimeSlot = useSetRecoilState(selectedTimeSlotState);

  return (
    <div className={classes.container}>
      <StepperBooking activeStep={2} />
      <div className={classes.wrapperContent}>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          style={{ minHeight: '100vh' }}
        >
          <Grid
            className={classes.inner}
            item
            xs={12}
          >
            <Box mb={2} mt={4}>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link
                component="button"
                onClick={() => {
                  if (window && window.gtag) {
                    window.gtag('event', 'select_content', {
                      content_name: 'Back to / Finalization / Complete Sign-up',
                      content_lang: intl.locale,
                    });
                  }
                  setSelectedTimeSlot(null);
                }}
              >
                <Typography variant="subtitle2" component="span">
                  <FormattedMessage id="SignupScreen.previousStep" />
                </Typography>
              </Link>
            </Box>

            <Box mb={1} mt={4}>
              <Typography variant="h4">
                <FormattedMessage id="SignupScreen.title" />
              </Typography>
            </Box>
            <Divider />

            <Grid
              container
              spacing={4}
              justifyContent="center"
              className={classes.colsWrapper}
            >
              <Grid
                item
                xs={12}
                md={6}
              >
                <SelectedTimeSlotDetails />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
              >
                <SignupForm />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

ScreenSignup.propTypes = {};

export default ScreenSignup;
